import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";

import type { StarIndicatorType } from "modules/Appointments/queryKeys";

export const useStarIndicatorsToFilter = () => useTypedQuery({ queryKey: AppointmentsQueryKeys.starIndicatorsToFilter, initialData: {} }).data;
export const setStarIndicatorsToFilter = (starIndicators: StarIndicatorType) =>
  typedQueryClient.setQueryData(AppointmentsQueryKeys.starIndicatorsToFilter, starIndicators);
